import { ContentContainerType } from 'types/enums';
import { Button, Flex, Grid, GridItem, Skeleton } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';

export const LabelV2VersionFormLoader = () => (
  <ContentContainer type={ContentContainerType.LIST} pb={24}>
    <Flex position="absolute" top={-16} right={4} gap={4}>
      <Button variant="secondary" size="md" isDisabled>
        Go to Song
      </Button>
      <Button variant="secondary" size="md" isDisabled>
        Sync
      </Button>
    </Flex>
    <Grid
      templateColumns="repeat(4, 1fr)"
      gap={4}
      w="full"
      maxW="640px"
      mx="auto"
    >
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={3} />
      </GridItem>
    </Grid>
  </ContentContainer>
);
